import { ActionReducerMap } from "@ngrx/store";

import { State, reducer } from "./companies.reducer";

export interface CompaniesState {
  filters: State;
}

export const CompaniesReducer: ActionReducerMap<CompaniesState> = {
  filters: reducer
};

export * from "./companies.reducer";
